import React from 'react';
import * as keyset from 'i18n/DraftsStatuses';
import i18n from '@yandex-int/i18n';
import { wrapInText } from 'client/lib/i18n-utils';
import { OperationType } from '../../model/operation';
import { Channel } from '../../model/skill';
import { draftStatusLabels } from './draftStatus';
import Link from '../../blocks/Link/Link';

const t = i18n(keyset);

const commonStrings: Record<OperationType, string> = {
    skillCreated: t('dialog-created'),
    skillWithdrawn: t('dialog-withdrawn'),
    skillStopped: t('dialog-stopped'),
    skillDeleted: t('dialog-deleted'),
    reviewRequested: t('review-requested'),
    reviewCancelled: t('review-cancelled'),
    reviewApproved: t('review-approved'),
    deployRequested: t('deploy-requested'),
    deployCompleted: t('deploy-complete'),
    deployRejected: t('deploy-rejected'),
    settingsReviewApproved: '',
    deviceTestPrepared: '',
    deviceTestStarted: '',
    deviceTestCompleted: '',
    skillNominated: t('skill-nominated'),
    skillNominationRotationCompleted: t('skill-nomination-cancelled'),
    skillNominationRotationWithdrawn: t('skill-nomination-cancelled'),
};

const smartHomeStrings: Record<OperationType, string> = {
    skillCreated: t('dialog-created'),
    skillWithdrawn: t('dialog-withdrawn'),
    skillStopped: t('dialog-stopped'),
    skillDeleted: t('dialog-deleted'),
    reviewRequested: t('review-requested'),
    reviewCancelled: t('review-cancelled'),
    reviewApproved: t('review-approved'),
    deployRequested: t('deploy-requested'),
    deployCompleted: t('deploy-complete'),
    deployRejected: t('deploy-rejected'),
    settingsReviewApproved: t('sh-meeting'),
    deviceTestPrepared: t('sh-waiting'),
    deviceTestStarted: t('sh-testing'),
    deviceTestCompleted: t('sh-analysis'),
    skillNominated: '',
    skillNominationRotationCompleted: '',
    skillNominationRotationWithdrawn: '',
};

const alicePrizePage = 'https://dialogs.yandex.ru/prize';

export const commonComments: Record<OperationType, React.ReactNode> = {
    skillCreated: t('comment-skill-created'),
    skillWithdrawn: '',
    skillStopped: '',
    skillDeleted: '',
    reviewRequested: '',
    reviewCancelled: '',
    reviewApproved: '',
    deployRequested: '',
    deployCompleted: '',
    deployRejected: '',
    settingsReviewApproved: '',
    deviceTestPrepared: '',
    deviceTestStarted: '',
    deviceTestCompleted: '',
    skillNominated: wrapInText((s) => (
        <Link to={alicePrizePage} target="_blank">
            {s}
        </Link>
    ))(t('alice-nominee')),
    skillNominationRotationCompleted: t('alice-nominee-testing-finished'),
    skillNominationRotationWithdrawn: '',
};

const commonShortStrings = {
    ...commonStrings,
};

const smartHomeShortStrings = {
    ...smartHomeStrings,
    settingsReviewApproved: draftStatusLabels.smartHome.meetingApproval,
    deviceTestPrepared: draftStatusLabels.smartHome.waitingForTesting,
    deviceTestStarted: draftStatusLabels.smartHome.devicesTesting,
    deviceTestCompleted: draftStatusLabels.smartHome.devicesTestingCompleted,
};

export const getOperationLabels = (channel: Channel) => {
    if (channel === Channel.SmartHome) return smartHomeStrings;
    return commonStrings;
};

export const getShortLabels = (channel: Channel) => {
    if (channel === Channel.SmartHome) return smartHomeShortStrings;
    return commonShortStrings;
};
